import React from 'react'
import { Box } from '@mui/material'
import { tourBulletSx, tourHighlightSx } from './platformTourStyles'

/** One line of "On this page". */
export const PlatformTourHighlight: React.FC<{ text: string }> = ({ text }) => (
  <Box component="li" sx={tourHighlightSx}>
    <Box sx={tourBulletSx} aria-hidden />
    {text}
  </Box>
)
